module.exports = __webpack_public_path__ + "static/preview-3029059a2df4ff5402f64c2118c40787.png";